import * as React from 'react';
import { Formik, Form, Field } from 'formik';
import { Button } from '@material-ui/core';
import { TextField, Checkbox } from 'formik-material-ui';
import Grid from "@material-ui/core/Grid/Grid";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import AccountCircle from "@material-ui/icons/AccountCircle";
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: 195,
        position: 'relative'
    },
    margin: {
        height: theme.spacing(3),
    },
    discountIcon: {
        position: 'absolute'
    },
    input: {
        width: '100%'
    },
    btn: {
        backgroundColor: '#3f51b5!important',
        color: '#fff!important',
        padding: '10px !important',
        '&:hover': {
            backgroundColor: '#ddd',
            transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
        }
    }
}));

export default function ContactsForm(props) {

    const classes = useStyles();

    return (
        <Formik
            initialValues={{
                email: '',
                name: '',
                phone: '',
                subscribe: false,
                comments: "Please send me availability and full information about this vehicle."
            }}
            validate={values => {
                const errors = {};
                if (!values.email) {
                    errors.email = 'Required';
                } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
                ) {
                    errors.email = 'Invalid email address';
                }
                if (!values.name) {
                    errors.name = 'Required';
                }

                return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
                props.handleContactInformation(values);
            }}
        >
            {({ submitForm, isSubmitting }) => (
                <Form>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Field
                                disabled={props.loading}
                                className={classes.input}
                                component={TextField}
                                name="name"
                                type="name"
                                required
                                label="Full Name"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <AccountCircle />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Field className={classes.input}
                                   disabled={props.loading}
                                component={TextField}
                                name="email"
                                type="email"
                                label="Email"
                                required

                                   InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EmailIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Field className={classes.input}
                                   disabled={props.loading}
                                component={TextField}
                                type="phone"
                                label="Phone Number"
                                name="phone"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PhoneIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        {props.comments ?
                        <Grid item xs={12}>
                            <p></p>
                            <Field className={classes.input}
                                   disabled={props.loading}
                                   component={TextField}
                                   type="comments"
                                   label="Comments"
                                   name="comments"
                                   variant="outlined"
                                   InputProps={{
                                       rows: 3,
                                       multiline: true,
                                   }}
                            />
                        </Grid> : null }
                        {/*<Grid item xs={12}>
                            <FormControlLabel className={classes.input}
                                control={<Field
                                    component={Checkbox}
                                    type="checkbox"
                                    label="Send me new offers on similar cars"
                                    name="subscribe"
                                    defaultChecked={true}
                                />}
                                label="Send me new offers on similar cars"
                                disabled={props.loading}
                            />
                        </Grid>*/}
                    </Grid>

                    <br />
                    <Button
                        className={classes.btn}
                        variant="contained"
                        color="primary"
                        disabled={props.loading}
                        onClick={submitForm}
                    >
                        {props.buttonLabel ? props.buttonLabel : 'Submit'}
                    </Button>
                </Form>
            )}
        </Formik>
    );
}